module.exports = __webpack_public_path__ + "static/media/city-wenda.951b1cd6.png";